import React from 'react';
import our_address from '../../../assets/media/home-page/our-address.png';
import TittleWithAnimation from './TittleWithAnimation';
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import { Tween } from 'react-gsap';




gsap.registerPlugin(ScrollTrigger);



const OurLocation = () => {
    return (
        <section id="find_us_by_map">
            <div className="container">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="map-location-text">
                            <h1 className="rouded-tittle">
                                <TittleWithAnimation
                                    word="Find Us By Map"
                                    _trigger="#find_us_by_map h1"
                                    _start= "150px bottom"
                                    _end= "250px bottom"
                                    _scrub={true}
                                />
                            </h1>


                            <Tween
                                to={{
                                    scrollTrigger: {
                                        trigger: ".our_location_describe",
                                        start: '100px bottom',
                                        end: 'center center',
                                        scrub: true,
                                        // markers: true
                                    },
                                    css: {
                                        opacity: 1,
                                        x:0
                                    }
                                }}
                            >
                                <div className='our_location_describe'>
                                    <p className="short-text-line">
                                        
                                    </p>

                                    <p className="our-main-address">
                                        <i className="fa-solid fa-map-location-dot"></i>
                                        1481 Osage Road, North Brunswick NJ 08902
                                    </p>
                                </div>
                            </Tween>

                        </div>
                    </div>

                    <div className="col-lg-6 ml-auto map-location-area">
                        <Tween
                            to={{
                                scrollTrigger: {
                                    trigger: ".map-location",
                                    start: '150px bottom',
                                    end: 'bottom bottom',
                                    scrub: true,
                                    // markers: true
                                },
                                css: {
                                    width: '100%'
                                }
                            }}
                        >
                            <div className="map-location">
                                <img src={our_address} alt="our_address"/>
                            </div>
                        </Tween>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default OurLocation